<template>
    <div style="background-color: whitesmoke;">
        <b-modal id="modal-1"  hide-footer hide-header centered no-close-on-backdrop>
            <b-progress value="100" max="100" animated variant="secondary"></b-progress>
        </b-modal>
        
        <CCardBody class="statistic_table_modify">            
            <CDataTable
                :items="items"
                :fields="fields"
                sorter                
                hover
                border
                striped
                outlined
            >
                <template v-slot:thead-top="props">                
                    <tr class="first_tr"> 
                        <th colspan="4"></th>
                        <th colspan="3">{{ $t('1X2 FT') }}</th>
                        <th colspan="3">{{ $t('1X2 HT') }}</th>
                        <th colspan="4">{{ $t('Over FT') }}</th>
                        <th colspan="4">{{ $t('Under FT') }}</th>
                        <th colspan="2">{{ $t('Over HT') }}</th>
                        <th colspan="2">{{ $t('Under HT') }}</th>
                        <th colspan="2">{{ $t('BTS') }}</th>
                        <th colspan="3">{{ $t('DC odds') }}</th>
                    </tr>
                </template>
                <template #sample="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>                    
                        <a :href="'/#/viewevents?idlist=' + item.total_matches" target="_blank">{{item.total_matches.length}}</a>
                    </td>
                   
                </template>
                
                <template #Home_FT="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span v-if="item['Home_FT_stat'].split(':').length == 3 && parseFloat(item['Home_FT_stat'].split(':')[2]) > 0" style="background-color: green; color: white; border-radius: 5px; padding: 5px;" :id="'Home_FT_stat_' + item.uuid + order">
                            {{ item['Home_FT_stat'].split(':')[2] }}
                        </span>
                        <span v-else-if="item['Home_FT_stat'].split(':').length == 3 && parseFloat(item['Home_FT_stat'].split(':')[2]) <= 0" :id="'Home_FT_stat_' + item.uuid + order">
                            {{ item['Home_FT_stat'].split(':')[2] }}
                        </span>
                        <span v-else :id="'Home_FT_stat_' + item.uuid + order">
                            -
                        </span>

                        <b-tooltip v-if="item['Home_FT_stat'].split(':').length == 3" :target="'Home_FT_stat_' + item.uuid + order" triggers="hover">
                            <p>avg odds: {{ item['Home_FT_stat'].split(':')[0] }}</p>
                            <p>total profits: {{ item['Home_FT_stat'].split(':')[1] }}</p>
                            <p>win/rate: {{ item['Home_FT_win'] + "%" }}</p>
                            <p>Odd available: {{ item['Home_FT_count'] }}</p>
                        </b-tooltip>

                        <b-tooltip v-else :target="'Home_FT_stat_' + item.uuid + order" triggers="hover">
                            <p>win/rate: {{ item['Home_FT_win'] + "%" }}</p>                            
                        </b-tooltip>
                    </td>
                   
                </template>
                <template #Away_FT="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span v-if="item['Away_FT_stat'].split(':').length == 3 && parseFloat(item['Away_FT_stat'].split(':')[2]) > 0" style="background-color: green; color: white; border-radius: 5px; padding: 5px;" :id="item.uuid + '-Away_FT_stat' + order">
                            {{ item['Away_FT_stat'].split(':')[2] }}
                        </span>
                        <span v-else-if="item['Away_FT_stat'].split(':').length == 3 && parseFloat(item['Away_FT_stat'].split(':')[2]) <= 0" :id="item.uuid + '-Away_FT_stat' + order">
                            {{ item['Away_FT_stat'].split(':')[2] }}
                        </span>
                        <span v-else :id="item.uuid + '-Away_FT_stat' + order">
                            -
                        </span>

                        <b-tooltip v-if="item['Away_FT_stat'].split(':').length == 3" :target="item.uuid + '-Away_FT_stat' + order" triggers="hover">
                            <p>avg odds: {{ item['Away_FT_stat'].split(':')[0] }}</p>
                            <p>total profits: {{ item['Away_FT_stat'].split(':')[1] }}</p>
                            <p>win/rate: {{ item['Away_FT_win'] + "%" }}</p>
                            <p>Odd available: {{ item['Away_FT_count'] }}</p>
                        </b-tooltip>
                        <b-tooltip v-else :target="item.uuid + '-Away_FT_stat' + order" triggers="hover">                            
                            <p>win/rate: {{ item['Away_FT_win'] + "%" }}</p>                            
                        </b-tooltip>
                    </td>
                   
                </template>
                <template #Draw_FT="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span v-if="item['Draw_FT_stat'].split(':').length == 3 && parseFloat(item['Draw_FT_stat'].split(':')[2]) > 0" style="background-color: green; color: white; border-radius: 5px; padding: 5px;" :id=" order + item.uuid + '-Draw_FT_stat'">
                            {{ item['Draw_FT_stat'].split(':')[2] }}
                        </span>
                        <span v-else-if="item['Draw_FT_stat'].split(':').length == 3 && parseFloat(item['Draw_FT_stat'].split(':')[2]) <= 0" :id=" order + item.uuid + '-Draw_FT_stat'">
                            {{ item['Draw_FT_stat'].split(':')[2] }}
                        </span>
                        <span v-else :id=" order + item.uuid + '-Draw_FT_stat'">
                            -
                        </span>
                        <b-tooltip v-if="item['Draw_FT_stat'].split(':').length == 3" :target=" order + item.uuid + '-Draw_FT_stat'" triggers="hover">
                            <p>avg odds: {{ item['Draw_FT_stat'].split(':')[0] }}</p>
                            <p>total profits: {{ item['Draw_FT_stat'].split(':')[1] }}</p>
                            <p>win/rate: {{ item['Draw_FT_win'] + "%" }}</p>
                            <p>Odd available: {{ item['Draw_FT_count'] }}</p>
                        </b-tooltip>
                        <b-tooltip v-else :target=" order + item.uuid + '-Draw_FT_stat'" triggers="hover">
                            <p>win/rate: {{ item['Draw_FT_win'] + "%" }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #Home_HT="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span v-if="item['Home_HT_stat'].split(':').length == 3 && parseFloat(item['Home_HT_stat'].split(':')[2]) > 0" style="background-color: green; color: white; border-radius: 5px; padding: 5px;" :id=" order + item.uuid + '-Home_HT_stat'">
                            {{ item['Home_HT_stat'].split(':')[2] }}
                        </span>
                        <span v-else-if="item['Home_HT_stat'].split(':').length == 3 && parseFloat(item['Home_HT_stat'].split(':')[2]) <= 0" :id=" order + item.uuid + '-Home_HT_stat'">
                            {{ item['Home_HT_stat'].split(':')[2] }}
                        </span>
                        <span v-else :id=" order + item.uuid + '-Home_HT_stat'">
                            -
                        </span>
                        <b-tooltip v-if="item['Home_HT_stat'].split(':').length == 3" :target=" order + item.uuid + '-Home_HT_stat'" triggers="hover">
                            <p>avg odds: {{ item['Home_HT_stat'].split(':')[0] }}</p>
                            <p>total profits: {{ item['Home_HT_stat'].split(':')[1] }}</p>
                            <p>win/rate: {{ item['Home_HT_win'] + "%" }}</p>
                            <p>Odd available: {{ item['Home_HT_count'] }}</p>
                        </b-tooltip>
                        <b-tooltip v-else :target=" order + item.uuid + '-Home_HT_stat'" triggers="hover">                            
                            <p>win/rate: {{ item['Home_HT_win'] + "%" }}</p>                            
                        </b-tooltip>
                    </td>
                </template>
                <template #Away_HT="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span v-if="item['Away_HT_stat'].split(':').length == 3 && parseFloat(item['Away_HT_stat'].split(':')[2]) > 0" style="background-color: green; color: white; border-radius: 5px; padding: 5px;" :id=" order + item.uuid + '-Away_HT_stat'">
                            {{ item['Away_HT_stat'].split(':')[2] }}
                        </span>
                        <span v-else-if="item['Away_HT_stat'].split(':').length == 3 && parseFloat(item['Away_HT_stat'].split(':')[2]) <= 0" :id=" order + item.uuid + '-Away_HT_stat'">
                            {{ item['Away_HT_stat'].split(':')[2] }}
                        </span>
                        <span v-else :id=" order + item.uuid + '-Away_HT_stat'">
                            -
                        </span>
                        <b-tooltip v-if="item['Away_HT_stat'].split(':').length == 3" :target=" order + item.uuid + '-Away_HT_stat'" triggers="hover">
                            <p>avg odds: {{ item['Away_HT_stat'].split(':')[0] }}</p>
                            <p>total profits: {{ item['Away_HT_stat'].split(':')[1] }}</p>
                            <p>win/rate: {{ item['Away_HT_win'] + "%" }}</p>
                            <p>Odd available: {{ item['Away_HT_count'] }}</p>
                        </b-tooltip>
                        <b-tooltip v-else :target=" order + item.uuid + '-Away_HT_stat'" triggers="hover">                            
                            <p>win/rate: {{ item['Away_HT_win'] + "%" }}</p>                            
                        </b-tooltip>
                    </td>
                </template>
                <template #Draw_HT="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span v-if="item['Draw_HT_stat'].split(':').length == 3 && parseFloat(item['Draw_HT_stat'].split(':')[2]) > 0" style="background-color: green; color: white; border-radius: 5px; padding: 5px;" :id=" order + item.uuid + '-Draw_HT_stat'">
                            {{ item['Draw_HT_stat'].split(':')[2] }}
                        </span>
                        <span v-else-if="item['Draw_HT_stat'].split(':').length == 3 && parseFloat(item['Draw_HT_stat'].split(':')[2]) <= 0" :id=" order + item.uuid + '-Draw_HT_stat'">
                            {{ item['Draw_HT_stat'].split(':')[2] }}
                        </span>
                        <span v-else :id=" order + item.uuid + '-Draw_HT_stat'">
                            -
                        </span>
                        <b-tooltip v-if="item['Draw_HT_stat'].split(':').length == 3" :target=" order + item.uuid + '-Draw_HT_stat'" triggers="hover">
                            <p>avg odds: {{ item['Draw_HT_stat'].split(':')[0] }}</p>
                            <p>total profits: {{ item['Draw_HT_stat'].split(':')[1] }}</p>
                            <p>win/rate: {{ item['Draw_HT_win'] + "%" }}</p>
                            <p>Odd available: {{ item['Draw_HT_count'] }}</p>
                        </b-tooltip>
                        <b-tooltip v-else :target=" order + item.uuid + '-Draw_HT_stat'" triggers="hover">
                            <p>win/rate: {{ item['Draw_HT_win'] + "%" }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #Over_0.5_FT="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span v-if="item['Over_0.5_FT_stat'].split(':').length == 3 && parseFloat(item['Over_0.5_FT_stat'].split(':')[2]) > 0" style="background-color: green; color: white; border-radius: 5px; padding: 5px;" :id=" order + item.uuid + '-Over_0.5_FT_stat'">
                            {{ item['Over_0.5_FT_stat'].split(':')[2] }}
                        </span>
                        <span v-else-if="item['Over_0.5_FT_stat'].split(':').length == 3 && parseFloat(item['Over_0.5_FT_stat'].split(':')[2]) <= 0" :id=" order + item.uuid + '-Over_0.5_FT_stat'">
                            {{ item['Over_0.5_FT_stat'].split(':')[2] }}
                        </span>
                        <span v-else :id=" order + item.uuid + '-Over_0.5_FT_stat'">
                            -
                        </span>
                        <b-tooltip v-if="item['Over_0.5_FT_stat'].split(':').length == 3" :target=" order + item.uuid + '-Over_0.5_FT_stat'" triggers="hover">
                            <p>avg odds: {{ item['Over_0.5_FT_stat'].split(':')[0] }}</p>
                            <p>total profits: {{ item['Over_0.5_FT_stat'].split(':')[1] }}</p>
                            <p>win/rate: {{ item['Over_0.5_FT_win'] + "%" }}</p>
                            <p>Odd available: {{ item['Over_0.5_FT_count'] }}</p>
                        </b-tooltip>
                        <b-tooltip v-else :target=" order + item.uuid + '-Over_0.5_FT_stat'" triggers="hover">
                            <p>win/rate: {{ item['Over_0.5_FT_win'] + "%" }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #Over_1.5_FT="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span v-if="item['Over_1.5_FT_stat'].split(':').length == 3 && parseFloat(item['Over_1.5_FT_stat'].split(':')[2]) > 0" style="background-color: green; color: white; border-radius: 5px; padding: 5px;" :id=" order + item.uuid + '-Over_1.5_FT_stat'">
                            {{ item['Over_1.5_FT_stat'].split(':')[2] }}
                        </span>
                        <span v-else-if="item['Over_1.5_FT_stat'].split(':').length == 3 && parseFloat(item['Over_1.5_FT_stat'].split(':')[2]) <= 0" :id=" order + item.uuid + '-Over_1.5_FT_stat'">
                            {{ item['Over_1.5_FT_stat'].split(':')[2] }}
                        </span>
                        <span v-else :id=" order + item.uuid + '-Over_1.5_FT_stat'">
                            -
                        </span>
                        <b-tooltip v-if="item['Over_1.5_FT_stat'].split(':').length == 3" :target=" order + item.uuid + '-Over_1.5_FT_stat'" triggers="hover">
                            <p>avg odds: {{ item['Over_1.5_FT_stat'].split(':')[0] }}</p>
                            <p>total profits: {{ item['Over_1.5_FT_stat'].split(':')[1] }}</p>
                            <p>win/rate: {{ item['Over_1.5_FT_win'] + "%" }}</p>
                            <p>Odd available: {{ item['Over_1.5_FT_count'] }}</p>
                        </b-tooltip>
                        <b-tooltip v-else :target=" order + item.uuid + '-Over_1.5_FT_stat'" triggers="hover">
                            <p>win/rate: {{ item['Over_1.5_FT_win'] + "%" }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #Over_2.5_FT="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span v-if="item['Over_2.5_FT_stat'].split(':').length == 3 && parseFloat(item['Over_2.5_FT_stat'].split(':')[2]) > 0" style="background-color: green; color: white; border-radius: 5px; padding: 5px;" :id=" order + item.uuid + '-Over_2.5_FT_stat'">
                            {{ item['Over_2.5_FT_stat'].split(':')[2] }}
                        </span>
                        <span v-else-if="item['Over_2.5_FT_stat'].split(':').length == 3 && parseFloat(item['Over_2.5_FT_stat'].split(':')[2]) <= 0" :id=" order + item.uuid + '-Over_2.5_FT_stat'">
                            {{ item['Over_2.5_FT_stat'].split(':')[2] }}
                        </span>
                        <span v-else :id=" order + item.uuid + '-Over_2.5_FT_stat'">
                            -
                        </span>
                        <b-tooltip v-if="item['Over_2.5_FT_stat'].split(':').length == 3" :target=" order + item.uuid + '-Over_2.5_FT_stat'" triggers="hover">
                            <p>avg odds: {{ item['Over_2.5_FT_stat'].split(':')[0] }}</p>
                            <p>total profits: {{ item['Over_2.5_FT_stat'].split(':')[1] }}</p>
                            <p>win/rate: {{ item['Over_2.5_FT_win'] + "%" }}</p>
                            <p>Odd available: {{ item['Over_2.5_FT_count'] }}</p>
                        </b-tooltip>
                        <b-tooltip v-else :target=" order + item.uuid + '-Over_2.5_FT_stat'" triggers="hover">
                            <p>win/rate: {{ item['Over_2.5_FT_win'] + "%" }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #Over_3.5_FT="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span v-if="item['Over_3.5_FT_stat'].split(':').length == 3 && parseFloat(item['Over_3.5_FT_stat'].split(':')[2]) > 0" style="background-color: green; color: white; border-radius: 5px; padding: 5px;" :id=" order + item.uuid + '-Over_3.5_FT_stat'">
                            {{ item['Over_3.5_FT_stat'].split(':')[2] }}
                        </span>
                        <span v-else-if="item['Over_3.5_FT_stat'].split(':').length == 3 && parseFloat(item['Over_3.5_FT_stat'].split(':')[2]) <= 0" :id=" order + item.uuid + '-Over_3.5_FT_stat'">
                            {{ item['Over_3.5_FT_stat'].split(':')[2] }}
                        </span>
                        <span v-else :id=" order + item.uuid + '-Over_3.5_FT_stat'">
                            -
                        </span>
                        <b-tooltip v-if="item['Over_3.5_FT_stat'].split(':').length == 3" :target=" order + item.uuid + '-Over_3.5_FT_stat'" triggers="hover">
                            <p>avg odds: {{ item['Over_3.5_FT_stat'].split(':')[0] }}</p>
                            <p>total profits: {{ item['Over_3.5_FT_stat'].split(':')[1] }}</p>
                            <p>win/rate: {{ item['Over_3.5_FT_win'] + "%" }}</p>
                            <p>Odd available: {{ item['Over_3.5_FT_count'] }}</p>
                        </b-tooltip>
                        <b-tooltip v-else :target=" order + item.uuid + '-Over_3.5_FT_stat'" triggers="hover">
                            <p>win/rate: {{ item['Over_3.5_FT_win'] + "%" }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #Under_0.5_FT="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span v-if="item['Under_0.5_FT_stat'].split(':').length == 3 && parseFloat(item['Under_0.5_FT_stat'].split(':')[2]) > 0" style="background-color: green; color: white; border-radius: 5px; padding: 5px;" :id=" order + item.uuid + '-Under_0.5_FT_stat'">
                            {{ item['Under_0.5_FT_stat'].split(':')[2] }}
                        </span>
                        <span v-else-if="item['Under_0.5_FT_stat'].split(':').length == 3 && parseFloat(item['Under_0.5_FT_stat'].split(':')[2]) <= 0" :id=" order + item.uuid + '-Under_0.5_FT_stat'">
                            {{ item['Under_0.5_FT_stat'].split(':')[2] }}
                        </span>
                        <span v-else :id=" order + item.uuid + '-Under_0.5_FT_stat'">
                            -
                        </span>
                        <b-tooltip v-if="item['Under_0.5_FT_stat'].split(':').length == 3" :target=" order + item.uuid + '-Under_0.5_FT_stat'" triggers="hover">
                            <p>avg odds: {{ item['Under_0.5_FT_stat'].split(':')[0] }}</p>
                            <p>total profits: {{ item['Under_0.5_FT_stat'].split(':')[1] }}</p>
                            <p>win/rate: {{ item['Under_0.5_FT_win'] + "%" }}</p>
                            <p>Odd available: {{ item['Under_0.5_FT_count'] }}</p>
                        </b-tooltip>
                        <b-tooltip v-else :target=" order + item.uuid + '-Under_0.5_FT_stat'" triggers="hover">
                            <p>win/rate: {{ item['Under_0.5_FT_win'] + "%" }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #Under_1.5_FT="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span v-if="item['Under_1.5_FT_stat'].split(':').length == 3 && parseFloat(item['Under_1.5_FT_stat'].split(':')[2]) > 0" style="background-color: green; color: white; border-radius: 5px; padding: 5px;" :id=" order + item.uuid + '-Under_1.5_FT_stat'">
                            {{ item['Under_1.5_FT_stat'].split(':')[2] }}
                        </span>
                        <span v-else-if="item['Under_1.5_FT_stat'].split(':').length == 3 && parseFloat(item['Under_1.5_FT_stat'].split(':')[2]) <= 0" :id=" order + item.uuid + '-Under_1.5_FT_stat'">
                            {{ item['Under_1.5_FT_stat'].split(':')[2] }}
                        </span>
                        <span v-else :id=" order + item.uuid + '-Under_1.5_FT_stat'">
                            -
                        </span>
                        <b-tooltip v-if="item['Under_1.5_FT_stat'].split(':').length == 3" :target=" order + item.uuid + '-Under_1.5_FT_stat'" triggers="hover">
                            <p>avg odds: {{ item['Under_1.5_FT_stat'].split(':')[0] }}</p>
                            <p>total profits: {{ item['Under_1.5_FT_stat'].split(':')[1] }}</p>
                            <p>win/rate: {{ item['Under_1.5_FT_win'] + "%" }}</p>
                            <p>Odd available: {{ item['Under_1.5_FT_count'] }}</p>
                        </b-tooltip>
                        <b-tooltip v-else :target=" order + item.uuid + '-Under_1.5_FT_stat'" triggers="hover">
                            <p>win/rate: {{ item['Under_1.5_FT_win'] + "%" }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #Under_2.5_FT="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span v-if="item['Under_2.5_FT_stat'].split(':').length == 3 && parseFloat(item['Under_2.5_FT_stat'].split(':')[2]) > 0" style="background-color: green; color: white; border-radius: 5px; padding: 5px;" :id=" order + item.uuid + '-Under_2.5_FT_stat'">
                            {{ item['Under_2.5_FT_stat'].split(':')[2] }}
                        </span>
                        <span v-else-if="item['Under_2.5_FT_stat'].split(':').length == 3 && parseFloat(item['Under_2.5_FT_stat'].split(':')[2]) <= 0" :id=" order + item.uuid + '-Under_2.5_FT_stat'">
                            {{ item['Under_2.5_FT_stat'].split(':')[2] }}
                        </span>
                        <span v-else :id=" order + item.uuid + '-Under_2.5_FT_stat'">
                            -
                        </span>
                        <b-tooltip v-if="item['Under_2.5_FT_stat'].split(':').length == 3" :target=" order + item.uuid + '-Under_2.5_FT_stat'" triggers="hover">
                            <p>avg odds: {{ item['Under_2.5_FT_stat'].split(':')[0] }}</p>
                            <p>total profits: {{ item['Under_2.5_FT_stat'].split(':')[1] }}</p>
                            <p>win/rate: {{ item['Under_2.5_FT_win'] + "%" }}</p>
                            <p>Odd available: {{ item['Under_2.5_FT_count'] }}</p>
                        </b-tooltip>
                        <b-tooltip v-else :target=" order + item.uuid + '-Under_2.5_FT_stat'" triggers="hover">
                            <p>win/rate: {{ item['Under_2.5_FT_win'] + "%" }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #Under_3.5_FT="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span v-if="item['Under_3.5_FT_stat'].split(':').length == 3 && parseFloat(item['Under_3.5_FT_stat'].split(':')[2]) > 0" style="background-color: green; color: white; border-radius: 5px; padding: 5px;" :id=" order + item.uuid + '-Under_3.5_FT_stat'">
                            {{ item['Under_3.5_FT_stat'].split(':')[2] }}
                        </span>
                        <span v-else-if="item['Under_3.5_FT_stat'].split(':').length == 3 && parseFloat(item['Under_3.5_FT_stat'].split(':')[2]) <= 0" :id=" order + item.uuid + '-Under_3.5_FT_stat'">
                            {{ item['Under_3.5_FT_stat'].split(':')[2] }}
                        </span>
                        <span v-else :id=" order + item.uuid + '-Under_3.5_FT_stat'">
                            -
                        </span>
                        <b-tooltip v-if="item['Under_3.5_FT_stat'].split(':').length == 3" :target=" order + item.uuid + '-Under_3.5_FT_stat'" triggers="hover">
                            <p>avg odds: {{ item['Under_3.5_FT_stat'].split(':')[0] }}</p>
                            <p>total profits: {{ item['Under_3.5_FT_stat'].split(':')[1] }}</p>
                            <p>win/rate: {{ item['Under_3.5_FT_win'] + "%" }}</p>
                            <p>Odd available: {{ item['Under_3.5_FT_count'] }}</p>
                        </b-tooltip>
                        <b-tooltip v-else :target=" order + item.uuid + '-Under_3.5_FT_stat'" triggers="hover">
                            <p>win/rate: {{ item['Under_3.5_FT_win'] + "%" }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #Over_0.5_HT="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span v-if="item['Over_0.5_HT_stat'].split(':').length == 3 && parseFloat(item['Over_0.5_HT_stat'].split(':')[2]) > 0" style="background-color: green; color: white; border-radius: 5px; padding: 5px;" :id=" order + item.uuid + '-Over_0.5_HT_stat'">
                            {{ item['Over_0.5_HT_stat'].split(':')[2] }}
                        </span>
                        <span v-else-if="item['Over_0.5_HT_stat'].split(':').length == 3 && parseFloat(item['Over_0.5_HT_stat'].split(':')[2]) <= 0" :id=" order + item.uuid + '-Over_0.5_HT_stat'">
                            {{ item['Over_0.5_HT_stat'].split(':')[2] }}
                        </span>
                        <span v-else :id=" order + item.uuid + '-Over_0.5_HT_stat'">
                            -
                        </span>
                        <b-tooltip v-if="item['Over_0.5_HT_stat'].split(':').length == 3" :target=" order + item.uuid + '-Over_0.5_HT_stat'" triggers="hover">
                            <p>avg odds: {{ item['Over_0.5_HT_stat'].split(':')[0] }}</p>
                            <p>total profits: {{ item['Over_0.5_HT_stat'].split(':')[1] }}</p>
                            <p>win/rate: {{ item['Over_0.5_HT_win'] + "%" }}</p>
                            <p>Odd available: {{ item['Over_0.5_HT_count'] }}</p>
                        </b-tooltip>
                        <b-tooltip v-else :target=" order + item.uuid + '-Over_0.5_HT_stat'" triggers="hover">
                            <p>win/rate: {{ item['Over_0.5_HT_win'] + "%" }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #Over_1.5_HT="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span v-if="item['Over_1.5_HT_stat'].split(':').length == 3 && parseFloat(item['Over_1.5_HT_stat'].split(':')[2]) > 0" style="background-color: green; color: white; border-radius: 5px; padding: 5px;" :id=" order + item.uuid + '-Over_1.5_HT_stat'">
                            {{ item['Over_1.5_HT_stat'].split(':')[2] }}
                        </span>
                        <span v-else-if="item['Over_1.5_HT_stat'].split(':').length == 3 && parseFloat(item['Over_1.5_HT_stat'].split(':')[2]) <= 0" :id=" order + item.uuid + '-Over_1.5_HT_stat'">
                            {{ item['Over_1.5_HT_stat'].split(':')[2] }}
                        </span>
                        <span v-else :id=" order + item.uuid + '-Over_1.5_HT_stat'">
                            -
                        </span>
                        <b-tooltip v-if="item['Over_1.5_HT_stat'].split(':').length == 3" :target=" order + item.uuid + '-Over_1.5_HT_stat'" triggers="hover">
                            <p>avg odds: {{ item['Over_1.5_HT_stat'].split(':')[0] }}</p>
                            <p>total profits: {{ item['Over_1.5_HT_stat'].split(':')[1] }}</p>
                            <p>win/rate: {{ item['Over_1.5_HT_win'] + "%" }}</p>
                            <p>Odd available: {{ item['Over_1.5_HT_count'] }}</p>
                        </b-tooltip>
                        <b-tooltip v-else :target=" order + item.uuid + '-Over_1.5_HT_stat'" triggers="hover">
                            <p>win/rate: {{ item['Over_1.5_HT_win'] + "%" }}</p>
                        </b-tooltip>
                    </td>
                </template>
                 <template #Under_0.5_HT="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span v-if="item['Under_0.5_HT_stat'].split(':').length == 3 && parseFloat(item['Under_0.5_HT_stat'].split(':')[2]) > 0" style="background-color: green; color: white; border-radius: 5px; padding: 5px;" :id=" order + item.uuid + '-Under_0.5_HT_stat'">
                            {{ item['Under_0.5_HT_stat'].split(':')[2] }}
                        </span>
                        <span v-else-if="item['Under_0.5_HT_stat'].split(':').length == 3 && parseFloat(item['Under_0.5_HT_stat'].split(':')[2]) <= 0" :id=" order + item.uuid + '-Under_0.5_HT_stat'">
                            {{ item['Under_0.5_HT_stat'].split(':')[2] }}
                        </span>
                        <span v-else :id=" order + item.uuid + '-Under_0.5_HT_stat'">
                            -
                        </span>
                        <b-tooltip v-if="item['Under_0.5_HT_stat'].split(':').length == 3" :target=" order + item.uuid + '-Under_0.5_HT_stat'" triggers="hover">
                            <p>avg odds: {{ item['Under_0.5_HT_stat'].split(':')[0] }}</p>
                            <p>total profits: {{ item['Under_0.5_HT_stat'].split(':')[1] }}</p>
                            <p>win/rate: {{ item['Under_0.5_HT_win'] + "%" }}</p>
                            <p>Odd available: {{ item['Under_0.5_HT_count'] }}</p>
                        </b-tooltip>
                        <b-tooltip v-else :target=" order + item.uuid + '-Under_0.5_HT_stat'" triggers="hover">
                            <p>win/rate: {{ item['Under_0.5_HT_win'] + "%" }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #Under_1.5_HT="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span v-if="item['Under_1.5_HT_stat'].split(':').length == 3 && parseFloat(item['Under_1.5_HT_stat'].split(':')[2]) > 0" style="background-color: green; color: white; border-radius: 5px; padding: 5px;" :id=" order + item.uuid + '-Under_1.5_HT_stat'">
                            {{ item['Under_1.5_HT_stat'].split(':')[2] }}
                        </span>
                        <span v-else-if="item['Under_1.5_HT_stat'].split(':').length == 3 && parseFloat(item['Under_1.5_HT_stat'].split(':')[2]) <= 0" :id=" order + item.uuid + '-Under_1.5_HT_stat'">
                            {{ item['Under_1.5_HT_stat'].split(':')[2] }}
                        </span>
                        <span v-else :id=" order + item.uuid + '-Under_1.5_HT_stat'">
                            -
                        </span>
                        <b-tooltip v-if="item['Under_1.5_HT_stat'].split(':').length == 3" :target=" order + item.uuid + '-Under_1.5_HT_stat'" triggers="hover">
                            <p>avg odds: {{ item['Under_1.5_HT_stat'].split(':')[0] }}</p>
                            <p>total profits: {{ item['Under_1.5_HT_stat'].split(':')[1] }}</p>
                            <p>win/rate: {{ item['Under_1.5_HT_win'] + "%" }}</p>
                            <p>Odd available: {{ item['Under_1.5_HT_count'] }}</p>
                        </b-tooltip>
                        <b-tooltip v-else :target=" order + item.uuid + '-Under_1.5_HT_stat'" triggers="hover">
                            <p>win/rate: {{ item['Under_1.5_HT_win'] + "%" }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #BTS_FT="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span v-if="item['BTS_FT_stat'].split(':').length == 3 && parseFloat(item['BTS_FT_stat'].split(':')[2]) > 0" style="background-color: green; color: white; border-radius: 5px; padding: 5px;" :id=" order + item.uuid + '-BTS_FT_stat'">
                            {{ item['BTS_FT_stat'].split(':')[2] }}
                        </span>
                        <span v-else-if="item['BTS_FT_stat'].split(':').length == 3 && parseFloat(item['BTS_FT_stat'].split(':')[2]) <= 0" :id=" order + item.uuid + '-BTS_FT_stat'">
                            {{ item['BTS_FT_stat'].split(':')[2] }}
                        </span>
                        <span v-else :id=" order + item.uuid + '-BTS_FT_stat'">
                            -
                        </span>
                        <b-tooltip v-if="item['BTS_FT_stat'].split(':').length == 3" :target=" order + item.uuid + '-BTS_FT_stat'" triggers="hover">
                            <p>avg odds: {{ item['BTS_FT_stat'].split(':')[0] }}</p>
                            <p>total profits: {{ item['BTS_FT_stat'].split(':')[1] }}</p>
                            <p>win/rate: {{ item['BTS_FT_win'] + "%" }}</p>
                            <p>Odd available: {{ item['BTS_FT_count'] }}</p>
                        </b-tooltip>
                        <b-tooltip v-else :target=" order + item.uuid + '-BTS_FT_stat'" triggers="hover">
                            <p>win/rate: {{ item['BTS_FT_win'] + "%" }}</p>
                        </b-tooltip>
                    </td>
                   
                </template>
                <template #No_BTS_FT="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span v-if="item['No_BTS_FT_stat'].split(':').length == 3 && parseFloat(item['No_BTS_FT_stat'].split(':')[2]) > 0" style="background-color: green; color: white; border-radius: 5px; padding: 5px;" :id=" order + item.uuid + '-No_BTS_FT_stat'">
                            {{ item['No_BTS_FT_stat'].split(':')[2] }}
                        </span>
                        <span v-else-if="item['No_BTS_FT_stat'].split(':').length == 3 && parseFloat(item['No_BTS_FT_stat'].split(':')[2]) <= 0" :id=" order + item.uuid + '-No_BTS_FT_stat'">
                            {{ item['No_BTS_FT_stat'].split(':')[2] }}
                        </span>
                        <span v-else :id=" order + item.uuid + '-No_BTS_FT_stat'">
                            -
                        </span>
                        <b-tooltip v-if="item['No_BTS_FT_stat'].split(':').length == 3" :target=" order + item.uuid + '-No_BTS_FT_stat'" triggers="hover">
                            <p>avg odds: {{ item['No_BTS_FT_stat'].split(':')[0] }}</p>
                            <p>total profits: {{ item['No_BTS_FT_stat'].split(':')[1] }}</p>
                            <p>win/rate: {{ item['No_BTS_FT_win'] + "%" }}</p>
                            <p>Odd available: {{ item['No_BTS_FT_count'] }}</p>
                        </b-tooltip>
                        <b-tooltip v-else :target=" order + item.uuid + '-No_BTS_FT_stat'" triggers="hover">
                            <p>win/rate: {{ item['No_BTS_FT_win'] + "%" }}</p>
                        </b-tooltip>
                    </td>
                   
                </template>

                <template #1X="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span v-if="item['1X_stat'].split(':').length == 3 && parseFloat(item['1X_stat'].split(':')[2]) > 0" style="background-color: green; color: white; border-radius: 5px; padding: 5px;" :id=" order + item.uuid + '-1X_stat'">
                            {{ item['1X_stat'].split(':')[2] }}
                        </span>
                        <span v-else-if="item['1X_stat'].split(':').length == 3 && parseFloat(item['1X_stat'].split(':')[2]) <= 0" :id=" order + item.uuid + '-1X_stat'">
                            {{ item['1X_stat'].split(':')[2] }}
                        </span>
                        <span v-else :id=" order + item.uuid + '-1X_stat'">
                            -
                        </span>
                        <b-tooltip v-if="item['1X_stat'].split(':').length == 3" :target=" order + item.uuid + '-1X_stat'" triggers="hover">
                            <p>avg odds: {{ item['1X_stat'].split(':')[0] }}</p>
                            <p>total profits: {{ item['1X_stat'].split(':')[1] }}</p>
                            <p>win/rate: {{ item['1X_win'] + "%" }}</p>
                            <p>Odd available: {{ item['1X_count'] }}</p>
                        </b-tooltip>
                        <b-tooltip v-else :target=" order + item.uuid + '-1X_stat'" triggers="hover">
                            <p>win/rate: {{ item['1X_win'] + "%" }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #X2="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span v-if="item['X2_stat'].split(':').length == 3 && parseFloat(item['X2_stat'].split(':')[2]) > 0" style="background-color: green; color: white; border-radius: 5px; padding: 5px;" :id=" order + item.uuid + '-X2_stat'">
                            {{ item['X2_stat'].split(':')[2] }}
                        </span>
                        <span v-else-if="item['X2_stat'].split(':').length == 3 && parseFloat(item['X2_stat'].split(':')[2]) <= 0" :id=" order + item.uuid + '-X2_stat'">
                            {{ item['X2_stat'].split(':')[2] }}
                        </span>
                        <span v-else :id=" order + item.uuid + '-X2_stat'">
                            -
                        </span>
                        <b-tooltip v-if="item['X2_stat'].split(':').length == 3" :target=" order + item.uuid + '-X2_stat'" triggers="hover">
                            <p>avg odds: {{ item['X2_stat'].split(':')[0] }}</p>
                            <p>total profits: {{ item['X2_stat'].split(':')[1] }}</p>
                            <p>win/rate: {{ item['X2_win'] + "%" }}</p>
                            <p>Odd available: {{ item['X2_count'] }}</p>
                        </b-tooltip>
                        <b-tooltip v-else :target=" order + item.uuid + '-X2_stat'" triggers="hover">
                            <p>win/rate: {{ item['X2_win'] + "%" }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #12="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span v-if="item['12_stat'].split(':').length == 3 && parseFloat(item['12_stat'].split(':')[2]) > 0" style="background-color: green; color: white; border-radius: 5px; padding: 5px;" :id=" order + item.uuid + '-12_stat'">
                            {{ item['12_stat'].split(':')[2] }}
                        </span>
                        <span v-else-if="item['12_stat'].split(':').length == 3 && parseFloat(item['12_stat'].split(':')[2]) <= 0" :id=" order + item.uuid + '-12_stat'">
                            {{ item['12_stat'].split(':')[2] }}
                        </span>
                        <span v-else :id=" order + item.uuid + '-12_stat'">
                            -
                        </span>
                        <b-tooltip v-if="item['12_stat'].split(':').length == 3" :target=" order + item.uuid + '-12_stat'" triggers="hover">
                            <p>avg odds: {{ item['12_stat'].split(':')[0] }}</p>
                            <p>total profits: {{ item['12_stat'].split(':')[1] }}</p>
                            <p>win/rate: {{ item['12_win'] + "%" }}</p>
                            <p>Odd available: {{ item['12_count'] }}</p>
                        </b-tooltip>
                        <b-tooltip v-else :target=" order + item.uuid + '-12_stat'" triggers="hover">
                            <p>win/rate: {{ item['12_win'] + "%" }}</p>
                        </b-tooltip>
                    </td>
                </template>
            </CDataTable>
        </CCardBody>
    </div>
</template>

<script>
import { Plotly } from 'vue-plotly'

export default {
    name: 'SearchStatsOddsTable',
    components: {
        Plotly,
       
    },
    props: {
        items: {
            type: Array,
            default: () => []
        },
        fields: {
            type: Array,
            default: () => []
        },
        order: {
            type: String,
            default: "0"
        }
    },
    data () {
        return {
            
        }
    },
    created() {
        
    },
    mounted: function (){
       
    },
    methods: {        
       
    }
}
</script>
<style scoped>

.table-responsive {
    max-height: 80vh !important;
    margin-top: 20px !important;
}

</style>
<style>

.table-responsive {
    max-height: 80vh !important;
    margin-top: 20px;
}
.statistic_table_modify > .table-responsive{
    margin-top: 20px !important;
}

thead {
    padding: 3px;
    position: sticky;
    top: 0;
    z-index: 1;
    /* width: 25vw; */
    background: white;
}
.first_tr{
    background-color: #bae1aa ;
}
.first_tr + tr{
    background-color: #dff0d8;
}
</style>